import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { GridBreakpointService } from '@frontend/sports/grid/core/feature/breakpoint';
import { SlotLayoutService } from '@frontend/sports/layout/feature';
import { DynamicLayoutSlotComponent, HtmlNode } from '@frontend/vanilla/core';
import { take } from 'rxjs';

import { MainContentLoaded } from '../perf-cdk/main-content-loaded.service';
import { ContentBoxComponent } from '../seo/content-box.component';

@Component({
    selector: 'ms-main-column',
    templateUrl: './main-column.component.html',
    providers: [GridBreakpointService],
    imports: [DynamicLayoutSlotComponent, RouterOutlet, ContentBoxComponent],
})
export class MainColumnComponent implements OnInit {
    private readonly htmlNode = inject(HtmlNode);

    constructor(
        private slotLayoutService: SlotLayoutService,
        private changeDetectorRef: ChangeDetectorRef,
        private mainContentLoaded: MainContentLoaded,
    ) {}

    ngOnInit(): void {
        this.slotLayoutService.innerFooterLoaded$.pipe(take(1)).subscribe((_) => this.changeDetectorRef.markForCheck());
    }

    setMainVisible(): void {
        this.mainContentLoaded.setLoaded();
        this.htmlNode.setCssClass('main-activated', true);
    }
}
